import { Input } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';

const TextAreaComponent = ({ onChange, value, disabledField }) => {
  const onChangeValue = (e) => {
    onChange(e.target.value);
  };

  return (
    <>
      <Input.TextArea onChange={onChangeValue} defaultValue={value}  disabled={disabledField}/>
    </>
  );
};

export default TextAreaComponent;

TextAreaComponent.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.string,
  disabledField: PropTypes.bool,
};
